var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chart-box" }, [
    _c(
      "div",
      { staticClass: "select-box" },
      [
        _c(
          "el-select",
          {
            attrs: {
              placeholder: "请选择",
              "popper-class": "select_type_pzgmfx",
            },
            on: { change: _vm.changeYear },
            model: {
              value: _vm.selectVal,
              callback: function ($$v) {
                _vm.selectVal = $$v
              },
              expression: "selectVal",
            },
          },
          _vm._l(_vm.options, function (item) {
            return _c("el-option", {
              key: item,
              attrs: { label: item, value: item },
            })
          }),
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tab-box flex" },
      _vm._l(_vm.typeList, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "tab-item",
            class: { active: _vm.active === index },
            on: {
              click: function ($event) {
                return _vm.changeType(index, item)
              },
            },
          },
          [_c("span", [_vm._v(_vm._s(item))])]
        )
      }),
      0
    ),
    _c("div", { ref: "ageChart", staticClass: "chart" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }